<template>
  <md-card style="z-index: 0">
    <md-card-content>
      <h3>CTA</h3>

      <md-progress-bar
        v-if="loading"
        md-mode="indeterminate"
      />

      <div v-else>
        <language-key-form
          v-for="([title, values]) in Object.entries(cta)"
          :key="title"
          :title="title"
          :values="values"
          @update="(newValue) => onUpdate(title, newValue)"
        />
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
    import LanguageKeyForm from "@/components/Forms/LanguageKeyForm";

    export default {
        components: { LanguageKeyForm },
        props: {
          cta: { type: Object, default() { return {}; } },
          loading: Boolean
        },
        methods: {
            onUpdate(index, newValue) {
               this.cta[index] = newValue;
               this.$emit("update:cta", this.cta);
            }
        }
    };
</script>
